import { styled } from '@mui/material/styles';
import { TURN_STYLES } from '@/styles/theme';

export const Label = styled('label')({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
});

export const HiddenInput = styled('input')({
  position: 'absolute',
  opacity: 0,
  width: 0,
  height: 0,
  margin: 0,

  '&:checked + span': {
    backgroundColor: '#E8EDF2',
    borderColor: '#E8EDF2',
    boxShadow: '0 0 0 2px #E8EDF2',
  },

  '&:checked + span::after': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: 9,
    height: 5,
    border: `2px solid ${TURN_STYLES.primaryAccentColor}`,
    borderTop: 0,
    borderRight: 0,
    transform: 'translate(-50%, -60%) rotate(-45deg)',
  },
});

export const Box = styled('span')({
  position: 'relative',
  display: 'grid',
  placeContent: 'center',
  width: 16,
  height: 16,
  borderRadius: 4,
  border: '1px solid #8083A3',
  transition: 'all 0.2s ease-in-out',

  '&:hover': {
    transform: 'scale(1.05)',
  },
});
